import { createApiClient } from "@k60/contracts";

/**
 * The only HTTP client in the app (scaffold plan §6.4).
 *
 * The base URL is empty by default, because the generated paths already carry
 * the `/api` prefix the server mounts them under — `/api/v1/health`. Setting a
 * base of `/api` asked for `/api/api/v1/health`, which 404s, which is why the
 * health dot in the header was red even with the API answering.
 *
 * Same origin in dev (Vite proxies `/api` to 127.0.0.1:8000) and in every
 * deployed environment (Caddy fronts both). `VITE_API_BASE_URL` stays for the
 * case where the two are split across origins.
 */
export const api = createApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
});
